<template>
  <span
    :style="{
      whiteSpace: 'no-wrap',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }"
  >
    <button
      class="button is-info is-light is-small is-outline is-rounded"
      @click="loadUpdateUnitGroup(unitGroupID)"
    >
      Edit</button
    >&nbsp;
    <button
      class="button is-info is-light is-small is-outline is-rounded"
      @click="confirmDeleteUnitGroup(unitGroupID)"
    >
      Delete
    </button>
  </span>
</template>

<script>
export default {
  props: {
    unitGroupID: Number,
    confirmDeleteUnitGroup: Function,
    loadUpdateUnitGroup: Function,
    loadUnitGroupUnit: Function
  }
}
</script>
